import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n";
import { track, loadPublicConfig } from "../lib/analytics";


const WhatsAppIcon = () => (
  <svg viewBox="0 0 32 32" className="h-7 w-7 fill-current" aria-hidden="true">
    <path d="M16 3C9.1 3 3.5 8.6 3.5 15.5c0 2.4.7 4.7 1.9 6.7L3.3 29l7-1.9c1.8 1 3.8 1.5 5.7 1.5 6.9 0 12.5-5.6 12.5-12.5S22.9 3 16 3zm0 22.8c-1.8 0-3.6-.5-5.2-1.4l-.4-.2-4.1 1.1 1.1-4-.2-.4a10.3 10.3 0 0 1-1.6-5.4C5.6 9.8 10.3 5.1 16 5.1s10.4 4.7 10.4 10.4S21.7 25.8 16 25.8zm5.7-7.7c-.3-.2-1.8-.9-2.1-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6l-1-2.3c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.2 2.4 3.6 5.8 5.1.8.3 1.4.6 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.8-.8 2.1-1.5.3-.7.3-1.3.2-1.5-.1-.1-.3-.2-.6-.4z" />
  </svg>
);

export const WhatsAppButton = () => {
  const { t } = useLang();
  const [number, setNumber] = useState(null);

  useEffect(() => {
    loadPublicConfig().then((d) => d?.whatsapp_number && setNumber(d.whatsapp_number));
  }, []);

  if (!number) return null;
  const text = encodeURIComponent(t("Hello YUXEL — I'd like to discuss a project."));

  return (
    <motion.a
      href={`https://wa.me/${number}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      onClick={() => track("whatsapp_click", { phone: number })}
      aria-label={t("Chat on WhatsApp")}
      initial={false}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.96 }}
      className="group fixed bottom-6 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full border border-white/25 bg-[#4B1020] text-white transition-colors hover:border-[#D8D2C8]"
    >
      <WhatsAppIcon />
    </motion.a>
  );
};
